import { useContext } from 'react';
import { ScreenSizeContext } from 'src/contexts/ScreenSizeContext';

interface IUseMediaQueryProps {
  max?: number;
  min?: number;
}

interface IUseMediaQueryResult {
  windowWidth: number;
  windowHeight: number;
  matchScreenSize: boolean;
}

const useMediaQuery = ({ max = Number.MAX_VALUE, min = 0 }: IUseMediaQueryProps): IUseMediaQueryResult => {
  const { width: windowWidth, height: windowHeight } = useContext(ScreenSizeContext);

  return {
    windowWidth,
    windowHeight,
    matchScreenSize: windowWidth <= max && windowWidth >= min,
  };
};

export default useMediaQuery;
